import { render, staticRenderFns } from "./classroomIntelligentBodyCreate.vue?vue&type=template&id=cbed040e&scoped=true"
import script from "./classroomIntelligentBodyCreate.vue?vue&type=script&lang=js"
export * from "./classroomIntelligentBodyCreate.vue?vue&type=script&lang=js"
import style0 from "./classroomIntelligentBodyCreate.vue?vue&type=style&index=0&id=cbed040e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbed040e",
  null
  
)

export default component.exports